import { Injectable } from '@angular/core';
import { TroubleshootingExternalParameters } from '../../components/troubleshooting-modalita/troubleshooter.pipe';
import { D365CustomerSegment } from '../../enums/d365/d365-customer-segment';
import { FeatureToggleService } from './feature-toggle.service';
import { Questions } from './troubleshooting-values.service';

export enum TroubleshootingTemplates {
    ATTIVAZIONE = 'ATTIVAZIONE',
    GENERICI = 'GENERICI',
    ANTICIPATO = 'ANTICIPATO',
}

@Injectable()
export class TroubleshootingQuestionsService {
    constructor(private featureToggleSrv: FeatureToggleService) {}

    public QUESTIONS: TroubleshootingQuestionsTemplates = {
        [TroubleshootingTemplates.ATTIVAZIONE]: [
            {
                labelId: 'HAS_METER',
                value: Questions.HAS_METER,
                visible: Questions.ANY,
            },
            {
                labelId: 'IS_ACTIVE_PWR',
                value: Questions.IS_ACTIVE,
                visible: Questions.POWER + Questions.HAS_METER,
            },
            {
                labelId: 'IS_ACTIVE_GAS',
                value: Questions.IS_ACTIVE,
                visible: Questions.GAS + Questions.HAS_METER,
            },
            {
                labelId: 'IS_EGL',
                value: Questions.IS_EGL,
                visible: Questions.IS_ACTIVE,
            },
            {
                labelId: 'IS_CONNECTED_GAS',
                subLabelId: 'IS_CONNECTED_GAS',
                value: Questions.IS_CONNECTED,
                visible: (answer, formValues) =>
                    (answer & Questions.GAS) === Questions.GAS && formValues[Questions.HAS_METER] === 0,
            },
            {
                labelId: 'NEVER_USED',
                value: Questions.NEVER_USED,
                visible: (answer, formValues) =>
                    (!!formValues[Questions.HAS_METER] && formValues[Questions.IS_ACTIVE] === 0) ||
                    ((answer & Questions.GAS) === Questions.GAS &&
                        formValues[Questions.HAS_METER] === 0 &&
                        !!formValues[Questions.IS_CONNECTED]),
            },
            {
                labelId: 'IS_CONNECTED_PWR',
                subLabelId: 'IS_CONNECTED_PWR',
                value: Questions.IS_CONNECTED,
                visible: (answer, formValues) =>
                    (answer & Questions.POWER) === Questions.POWER && formValues[Questions.HAS_METER] === 0,
            },
            {
                labelId: 'MODIFIED_WIRING',
                value: Questions.MODIFIED_WIRING,
                visible: (answer, formValues) =>
                    ((!!formValues[Questions.HAS_METER] && formValues[Questions.IS_ACTIVE] === 0) ||
                        (formValues[Questions.HAS_METER] === 0 && !!formValues[Questions.IS_CONNECTED])) &&
                    formValues[Questions.NEVER_USED] === 0,
            },
        ],
        [TroubleshootingTemplates.GENERICI]: [
            {
                labelId: 'IS_ACTIVE_PWR',
                value: Questions.IS_ACTIVE,
                visible: Questions.POWER,
            },
            {
                labelId: 'IS_EGL_PWR',
                value: Questions.IS_EGL,
                visible: Questions.POWER + Questions.IS_ACTIVE,
            },
            {
                labelId: 'ACCOUNT_OWNERSHIP_PWR',
                value: Questions.ACCOUNT_OWNERSHIP,
                visible: Questions.POWER + Questions.IS_ACTIVE,
            },
            {
                labelId: 'IS_ACTIVE_GAS',
                value: Questions.IS_ACTIVE,
                visible: Questions.GAS,
            },
            {
                labelId: 'IS_EGL_GAS',
                value: Questions.IS_EGL,
                visible: Questions.GAS + Questions.IS_ACTIVE,
            },
            {
                labelId: 'ACCOUNT_OWNERSHIP_GAS',
                value: Questions.ACCOUNT_OWNERSHIP,
                visible: Questions.GAS + Questions.IS_ACTIVE,
            },
            {
                labelId: 'IS_BASEMENT_ACTIVATION',
                value: Questions.IS_BASEMENT,
                // POWER e Linea NON Attiva
                visible: (answer, formValues, params) =>
                    params?.customerSegment === D365CustomerSegment.Residential && // residenziale e ...
                    answer & Questions.POWER &&
                    formValues[Questions.IS_ACTIVE] === 0,
            },
            {
                labelId: 'IS_BASEMENT_SWITCH',
                value: Questions.IS_BASEMENT,
                visible: (answer, formValues, params) =>
                    // residenziale e ...
                    params?.customerSegment === D365CustomerSegment.Residential &&
                    // POWER e ...
                    answer & Questions.POWER &&
                    // fornitura Attiva e ...
                    !!formValues[Questions.IS_ACTIVE] &&
                    // fornitore EGL e ...
                    formValues[Questions.IS_EGL] === 0 &&
                    // typeof formValues[Questions.ACCOUNT_OWNERSHIP] === 'number' &&
                    // Sei il titolare e swinE2E abilitato
                    ((!!formValues[Questions.ACCOUNT_OWNERSHIP] && this.featureToggleSrv.isSwitchInE2EEnabled) ||
                        // oppure Non sei titolare e VolturaSwin Abilitata
                        (!formValues[Questions.ACCOUNT_OWNERSHIP] && this.featureToggleSrv.isVolturaSwitchEnabled)),
            },
        ],
        [TroubleshootingTemplates.ANTICIPATO]: [
            {
                labelId: 'IS_ACTIVE_PWR_GAS',
                value: Questions.IS_ACTIVE,
                visible: Questions.ANY,
            },
            {
                labelId: 'IS_EGL_PWR_GAS',
                value: Questions.IS_EGL,
                visible: Questions.IS_ACTIVE,
            },
            {
                labelId: 'IS_EGL_CHANGE_PRODUCT',
                value: Questions.ACCOUNT_OWNERSHIP,
                visible: Questions.IS_ACTIVE,
                isValueInverted: true,
            },
        ],
    };
}

export type TroubleshootingQuestionsTemplates = {
    [key in TroubleshootingTemplates]?: TroubleshootingQuestion[];
};

export type TroubleshootingQuestion = {
    value: number;
    visible:
        | number
        | ((
              answer: number,
              formValues: TroubleshootingFormValues,
              params?: TroubleshootingExternalParameters
          ) => boolean);
    isValueInverted?: boolean;
} & (
    | { label: string; labelId?: never; subLabel?: string; subLabelId?: never }
    | { labelId: string; label?: never; subLabelId?: string; subLabel?: never }
);

export type TroubleshootingFormValues = {
    [key in Questions]?: number;
};
